
import { apiRequest } from "./ApiUtility";

export async function getPatients(authContext) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }
  
  const url = `/api/patient/lastaccessed/${authContext.selectedFacility.id}`;
  return await apiRequest("get", url, authContext);
}

export async function searchPatients(authContext, keyword) {
  console.log(authContext);
  
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }
  
  const url = `/api/patient/facility/${authContext.selectedFacility.id}/patientsearch/${keyword}`;
  return await apiRequest("get", url, authContext);
}

export async function getPatientDetails(authContext, patientId) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }
  
  const url = `/api/patient/${patientId}/facility/${authContext?.selectedFacility?.id}`;
  return await apiRequest("get", url, authContext);
}

export async function addPatient(authContext, patient) {
  if (!patient) {
    return {
      isSuccess: false,
      data: "Patient data is undefined"
    };
  }
  
  const url = "/api/patient";
  const data = {
    facilityId: authContext.selectedFacility.id,
    firstName: patient.firstName,
    lastName: patient.lastName,
    gender: patient.gender,
    dateOfBirth: patient.dateOfBirth,
    emailId: patient.email,
    mobileNo: patient.phone,
    photo: patient.photo,
    bloodGroup: patient.bloodGroup,
    maritalStatus: patient.maritalStatus,
    emergencyContactPerson: patient.emergencyContactPerson,
    emergencyContactRelationship: patient.emergencyRelationship,
    emergencyContactPhoneNumber: patient.emergencyPhone,
    addressHouseNo: patient.addressHouseNo,
    addressStreet: patient.addressStreet,
    addressPIN: patient.addressPIN,
    addressCountry: patient.addressCountry,
    addressState: patient.addressState,
    addressCity: patient.addressCity,
    nationalIdType: patient.nationalIdType,
    nationalId: patient.nationalId,
    prefix: patient.prefix,
    suffix: patient.suffix,
  };
  
  return await apiRequest("post", url, authContext, data);
}

export async function updatePatient(authContext, patientId, patient) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }
  
  const url = `/api/patient/${patientId}`;
  const data = {
    firstName: patient?.firstName,
    lastName: patient?.lastName,
    gender: patient?.gender,
    dateOfBirth: patient?.dateOfBirth,
    emailId: patient?.emailId,
    mobileNo: patient?.mobileNo,
    isActive: true,
    prefix: patient?.prefix,
    suffix: patient?.suffix,
    nationalIdType: patient?.nationalIdType,
    nationalId: patient?.nationalId,
    maritalStatus: patient?.maritalStatus,
    emergencyContactRelationship: patient?.emergencyContactRelationship,
    photo: patient?.photo,
    bloodGroup: patient?.bloodGroup,
    emergencyContactPerson: patient?.emergencyContactPerson,
    emergencyContactPhoneNumber: patient?.emergencyContactPhoneNumber,
    addressHouseNo: patient?.addressHouseNo,
    addressStreet: patient?.addressStreet,
    addressPIN: patient?.addressPIN,
    addressCountry: patient?.addressCountry,
    addressState: patient?.addressState,
    addressCity: patient?.addressCity
  };
  
  return await apiRequest("put", url, authContext, data);
}

